import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/fantasy' },
  { label: '排行榜', href: '/category/action' },
  { label: '最新上架', href: '/category/romance' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`text-xl font-bold font-heading ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/80 hover:text-white'
                } ${location.pathname === item.href ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/category/fantasy"
              className="bg-primary-500 text-white dark:text-foreground-950 text-sm font-medium px-5 py-2 rounded-md whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-sm font-medium py-2 cursor-pointer ${
                  location.pathname === item.href ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm text-foreground-600 py-2 cursor-pointer"
            >
              关于我们
            </Link>
            <Link
              to="/category/fantasy"
              className="bg-primary-500 text-white dark:text-foreground-950 text-sm font-medium px-5 py-2 rounded-md text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}